import type { ApplicationConfig } from ".";
import { devConfig } from "./dev.config";

export const localConfig: ApplicationConfig = {
  ...devConfig,
};
